import React from 'react';
// routes
import { Outlet } from 'react-location';
// theme
import ThemeProvider from './theme';
// components
// import Settings from './components/settings';
// import ScrollToTop from './components/ScrollToTop';
import { BreakpointIndicator } from 'mui-breakpoint-indicator';
import TopLoadingBar from 'src/components/TopLoadingBar';
import NotistackProvider from './components/NotistackProvider';
import { ProgressBarStyle } from './components/ProgressBar';
import RtlLayout from './components/RtlLayout';
import ThemeColorPresets from './components/ThemeColorPresets';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import OnboardingRedirect from './guards/OnboardingRedirect';
// 3rd party
import { useAuth0 } from '@auth0/auth0-react';
import { useIntercom } from 'react-use-intercom';
import useCurrentUser from './hooks/core-api/useCurrentUser';

// ----------------------------------------------------------------------
declare global {
  interface Window {
    profitwell: (action: string, userId: string) => void;
  }
}

const App = () => {
  const { user } = useAuth0();
  const { boot } = useIntercom();
  const currentUserQuery = useCurrentUser();

  const { data } = currentUserQuery;
  const { intercom_identity_verification_hash, stripe_customer_id, is_marketing_customer } = data || {};

  React.useEffect(() => {
    if (is_marketing_customer) {
      // This page is meant for Phone/AI customers and not marketing customers
      window.location.href = 'https://app.lovagemarketing.com';
      return;
    }
  }, [is_marketing_customer]);

  if (user) {
    if (intercom_identity_verification_hash) {
      const userId = user.sub;
      boot({
        userId,
        userHash: intercom_identity_verification_hash.platform.web,
      });
    }

    if (stripe_customer_id) {
      // Using ProfitWell retain for reducing churn
      window.profitwell('user_id', stripe_customer_id);
    }
  }

  return (
    <ThemeProvider>
      {process.env.NODE_ENV !== 'production' && <BreakpointIndicator position="top-center" />}
      <ThemeColorPresets>
        <RtlLayout>
          <NotistackProvider>
            <MotionLazyContainer>
              <ProgressBarStyle />
              <TopLoadingBar />

              {/* <Settings /> */}
              {/* <ScrollToTop /> */}
              <OnboardingRedirect />
              <Outlet />
            </MotionLazyContainer>
          </NotistackProvider>
        </RtlLayout>
      </ThemeColorPresets>
    </ThemeProvider>
  );
};

export default App;
